import api from './apiService';
import apiRoutes from './apiRoutes';

// V2 returns { items: [{ id, name }] }; map back to the legacy { qualificationId, qualificationName } shape.
export const getAllQualificationsAsync = async () => {
  try {
    const response = await api.get(apiRoutes.getAllQualifications);
    return (response.result.items || []).map((x) => ({
      qualificationId: x.id,
      qualificationName: x.name,
    }));
  } catch (error) {
    throw error;
  }
};
